import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductReference } from "src/app/models/layout/product-reference";
import { LayoutService } from 'src/app/services/layout.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-segment-report-modal',
    templateUrl: './segment-report-modal.component.html',
    styleUrls: ['./segment-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, DecimalPipe]
})
export class SegmentReportModalComponent implements OnInit {
  reportData: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private layoutService: LayoutService
  ) {}

  ngOnInit() {
    this.generateReport();
  }

  generateReport() {
    const products = this.layoutService.planogramItems;
    const actualFacingCounts = this.layoutService.getActualFacingCounts();
    
    const totalProducts = products.size;
    const totalSales = Array.from(products.values()).reduce((sum, p) => sum + p.salesData.sales, 0);
    const totalSalesQty = Array.from(products.values()).reduce((sum, p) => sum + p.salesData.salesQty, 0);
    const totalFacings = Array.from(actualFacingCounts.values()).reduce((sum, count) => sum + count, 0);

    // Group products by segment (categoryLevel2)
    const groupedBySegment = Array.from(products.values()).reduce((groups, product) => {
      const key = product.categoryLevel2;
      (groups[key] = groups[key] || []).push(product);
      return groups;
    }, {} as Record<string, ProductReference[]>);

    this.reportData = Object.entries(groupedBySegment)
      .map(([segment, group]) => {
        const totalSkus = group.length;
        const segmentSales = group.reduce((sum, p) => sum + p.salesData.sales, 0);
        const segmentSalesQty = group.reduce((sum, p) => sum + p.salesData.salesQty, 0);
        const segmentFacings = group.reduce((sum, p) => sum + (actualFacingCounts.get(p.productId) || 0), 0);
        const rangeContribution = (100 / totalProducts) * totalSkus;
        const salesContribution = (100 / totalSales) * segmentSales;
        const volumeContribution = (100 / totalSalesQty) * segmentSalesQty;
        const planoFacings = totalFacings > 0 ? (100 / totalFacings) * segmentFacings : 0;
        const volumeVariance = Math.abs(planoFacings) - Math.abs(volumeContribution);
        let varianceColor = 0;

        if (Math.abs(volumeVariance) > 3 && Math.abs(volumeVariance) < 5) {
          varianceColor = 1;
        } else if (Math.abs(volumeVariance) >= 5) {
          varianceColor = 2;
        }

        return {
          segment,
          totalSkus,
          rangeContribution,
          salesContribution,
          volumeContribution,
          planoFacings,
          volumeVariance,
          varianceColor
        };
      })
      .sort((a, b) => b.volumeContribution - a.volumeContribution);
  }

  close() {
    this.activeModal.close();
  }
}
